var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowToCreateProj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 173,
    viewBox: "0 0 220 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3636 78.5167C31.3636 78.5167 23.9226 85.2784 27.064 97.5462C29.2355 105.939 35.8658 127.949 11.9795 127.357L12.5875 132.783C12.5875 132.783 36.5244 135.908 40.3318 115.587C44.6747 92.6174 31.3636 78.5167 31.3636 78.5167Z",
    fill: "#00A0F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M31.3636 78.5167C31.3636 78.5167 23.9226 85.2784 27.064 97.5462C29.2355 105.939 35.8658 127.949 11.9795 127.357L12.5875 132.783C12.5875 132.783 36.5244 135.908 40.3318 115.587C44.6747 92.6174 31.3636 78.5167 31.3636 78.5167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M197.011 34.0499H42.7852V133.953H197.011V34.0499Z",
    fill: "#C9C9C9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.249 122.544L102.386 159.643H141.458L132.475 122.544H108.249Z",
    fill: "#C9C9C9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M120.944 173C175.651 173 220 170.402 220 167.198C220 163.994 175.651 161.396 120.944 161.396C66.2374 161.396 21.8887 163.994 21.8887 167.198C21.8887 170.402 66.2374 173 120.944 173Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.011 111.134H42.7852V133.952H197.011V111.134Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.763 127.364C124.185 127.364 126.959 124.598 126.959 121.187C126.959 117.775 124.185 115.01 120.763 115.01C117.341 115.01 114.567 117.775 114.567 121.187C114.567 124.598 117.341 127.364 120.763 127.364Z",
    fill: "#A5A5A5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.42 153.141H93.4746V165.062H148.42V153.141Z",
    fill: "#E6E6E6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M42.8145 57.4525C42.8145 57.4525 49.0032 53.765 50.6969 60.4328C52.3907 67.1007 53.6646 74.4902 59.5493 76.2294C65.434 77.9685 44.7905 70.7089 44.7905 70.7089L42.8145 57.4525Z",
    fill: "#A5A5A5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3298 46.7072C56.8209 46.7072 58.0296 45.5021 58.0296 44.0155C58.0296 42.529 56.8209 41.3239 55.3298 41.3239C53.8387 41.3239 52.6299 42.529 52.6299 44.0155C52.6299 45.5021 53.8387 46.7072 55.3298 46.7072Z",
    fill: "#24285B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3561 46.7072C64.8472 46.7072 66.056 45.5021 66.056 44.0155C66.056 42.529 64.8472 41.3239 63.3561 41.3239C61.865 41.3239 60.6562 42.529 60.6562 44.0155C60.6562 45.5021 61.865 46.7072 63.3561 46.7072Z",
    fill: "#00A0F3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9206 46.7072C72.4117 46.7072 73.6205 45.5021 73.6205 44.0155C73.6205 42.529 72.4117 41.3239 70.9206 41.3239C69.4295 41.3239 68.2207 42.529 68.2207 44.0155C68.2207 45.5021 69.4295 46.7072 70.9206 46.7072Z",
    fill: "#FFD200"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9975 162.58C34.9975 162.58 33.6295 164.514 31.6389 164.146C29.6484 163.778 28.6206 165.538 30.2347 166.512C31.8488 167.487 36.9735 166.469 36.9735 166.469L37.6177 163.633L34.9975 162.58Z",
    fill: "#00A0F3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70.095 78.5167C70.095 78.5167 77.3767 78.5528 79.6567 93.5122C81.9368 108.472 84.6656 133.31 59.5488 133.57V115.796L70.095 78.5167Z",
    fill: "#A5A5A5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6991 70.7305C48.6991 70.7305 69.2413 70.7305 71.6589 82.0962C74.0764 93.4619 60.9752 127.451 60.9752 127.451L37.8127 126.455C37.8127 126.455 38.7827 113.812 35.2866 103.586C31.7905 93.3609 18.7544 74.9881 48.6991 70.7305Z",
    fill: "#00A0F3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M59.5488 83.467C59.5488 83.467 53.0344 90.0122 56.3205 100.382C59.6067 110.752 36.9727 110.485 36.9727 110.485C37.3236 112.653 37.5651 114.838 37.6965 117.03C37.6965 117.03 47.5695 124.427 62.7698 122.529L63.6818 119.931L67.5833 110.377L59.5488 83.467Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7435 59.4007C34.7435 59.4007 36.1115 63.5717 37.9283 65.9531C38.1045 66.1842 38.3248 66.3783 38.5765 66.5241C38.8283 66.67 39.1065 66.7647 39.3951 66.803C39.6837 66.8412 39.977 66.8221 40.2582 66.7469C40.5394 66.6716 40.8029 66.5416 41.0335 66.3644C41.8121 65.8406 42.4219 65.1033 42.7892 64.2415C43.1566 63.3796 43.2658 62.4302 43.1037 61.5079L42.8141 57.4739C42.6704 56.6722 42.2805 55.9348 41.6983 55.3635C41.1162 54.7921 40.3705 54.4151 39.5642 54.2843C36.582 53.6132 33.817 56.9038 34.7435 59.4007Z",
    fill: "#FEC2B2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6907 59.7184L48.6996 70.7305L42.1779 75.5582L40.875 65.1956L43.6907 59.7184Z",
    fill: "#FEC2B2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8227 59.1482C37.0968 58.6651 38.3111 58.038 39.4419 57.2792C39.3145 57.9803 39.3961 58.7033 39.6765 59.3587C39.957 60.0141 40.424 60.5732 41.0198 60.9667C41.5886 61.3617 42.2777 61.5468 42.9686 61.4902C43.6595 61.4335 44.309 61.1387 44.8054 60.6564L42.5037 55.504C42.2064 54.7594 41.7135 54.1085 41.0766 53.6196C40.4397 53.1307 39.6825 52.8219 38.8845 52.7257C38.1881 52.6421 37.4868 52.6059 36.7854 52.6174C35.0338 52.6174 33.2676 54.5731 31.4943 54.1401C31.3149 54.0918 31.1258 54.0915 30.9463 54.1393C30.7668 54.1871 30.603 54.2813 30.4716 54.4123C30.3402 54.5433 30.2458 54.7065 30.1979 54.8855C30.1499 55.0645 30.1502 55.2529 30.1986 55.4318C30.6402 57.106 31.9792 59.4657 34.4837 59.4224C34.9419 59.4037 35.3942 59.3111 35.8227 59.1482Z",
    fill: "#24285B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5205 61.0604C40.5205 61.0604 39.8905 59.4944 41.107 59.1192C42.3235 58.7439 43.2793 61.0027 41.7587 61.883L40.5205 61.0604Z",
    fill: "#FEC2B2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7428 61.9843L35.2649 64.0193C35.2448 64.133 35.2523 64.2499 35.2869 64.3601C35.3215 64.4703 35.3822 64.5707 35.4638 64.6527C35.5454 64.7347 35.6455 64.796 35.7558 64.8315C35.8661 64.8669 35.9833 64.8754 36.0976 64.8564L37.7703 64.4955L35.7428 61.9843Z",
    fill: "#FEC2B2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M41.0547 66.3645C41.0547 66.3645 42.5464 64.3223 42.5536 63.0017C43.1137 64.1589 43.3143 65.4563 43.1299 66.7278C42.9454 67.9993 42.3842 69.187 41.5181 70.1387L41.0547 66.3645Z",
    fill: "#CE8172"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4385 79.9602C62.0947 79.2181 62.9291 78.6542 63.8634 78.3213C64.7978 77.9884 65.8017 77.8973 66.781 78.0567C67.7603 78.216 68.683 78.6206 69.4628 79.2324C70.2425 79.8443 70.8537 80.6434 71.2391 81.555C74.0114 88.0497 77.189 99.5958 72.4407 112.138C65.2024 131.312 36.5244 110.146 36.5244 110.146L40.8674 105.455C40.8674 105.455 55.9519 112.564 61.938 108.869C66.9034 105.802 53.9904 88.5837 61.4385 79.9602Z",
    fill: "#00A0F3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M61.4385 79.9602C62.0947 79.2181 62.9291 78.6542 63.8634 78.3213C64.7978 77.9884 65.8017 77.8973 66.781 78.0567C67.7603 78.216 68.683 78.6206 69.4628 79.2324C70.2425 79.8443 70.8537 80.6434 71.2391 81.555C74.0114 88.0497 77.189 99.5958 72.4407 112.138C65.2024 131.312 36.5244 110.146 36.5244 110.146L40.8674 105.455C40.8674 105.455 55.9519 112.564 61.938 108.869C66.9034 105.802 53.9904 88.5837 61.4385 79.9602Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1182 109.504C37.1182 109.504 32.0948 108.522 31.7185 104.546C31.3421 100.57 37.2268 106.437 38.2691 104.546C39.3114 102.655 41.2947 102.583 40.8314 105.455L37.1182 109.504Z",
    fill: "#FEC2B2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.373 154.353C55.373 154.353 57.1392 155.934 56.5312 157.86C55.9232 159.787 57.5518 161.021 58.7026 159.542C59.8535 158.062 59.4844 152.867 59.4844 152.867L56.7411 151.885L55.373 154.353Z",
    fill: "#00A0F3"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6175 163.633L33.6943 162.58L44.7906 131.636L40.3318 126.534L60.9754 127.451C60.8724 129.311 60.3762 131.128 59.5192 132.783C58.6622 134.438 57.4638 135.894 56.0027 137.055C54.0835 138.538 52.3507 140.246 50.8418 142.143C45.6877 148.823 41.2551 156.026 37.6175 163.633Z",
    fill: "#24285B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7839 126.419L37.1686 141.501C37.1088 142.898 37.4626 144.282 38.1859 145.481C38.9092 146.679 39.9701 147.639 41.2365 148.241L55.7131 155.147L57.1607 151.662L48.7498 145.571C47.6627 144.784 46.8556 143.672 46.4456 142.396C46.0355 141.12 46.044 139.748 46.4698 138.477L50.3133 126.931L37.7839 126.419Z",
    fill: "#24285B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M145.943 52.8221H91.9639V101.655H145.943V52.8221Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M145.943 90.6921H91.9639V101.655H145.943V90.6921Z",
    fill: "#FFD200"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M12.457 131.643C12.457 131.643 5.21872 131.845 5.58787 127.415C5.95703 122.984 11.9793 127.357 11.9793 127.357L12.457 131.643Z",
    fill: "#FEC2B2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30409 116.667L0 123.405L11.67 130.809L15.9741 124.071L4.30409 116.667Z",
    fill: "#FFD200"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.018 61.7749H174.044V74.1581H197.018V61.7749Z",
    fill: "#A5A5A5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M5.58798 108.45C5.58798 108.45 -14.9397 30.3768 30.1981 8.02062C40.3896 2.96919 104.89 -10.0202 165.829 21.1327",
    stroke: "black",
    strokeWidth: 1.44822,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.45 7.24"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M202.708 158.127C202.708 158.127 196.548 156.446 195.209 150.723C195.209 150.723 204.756 148.804 205.024 158.661L202.708 158.127Z",
    fill: "#00A0F3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.73,
    d: "M203.468 157.514C203.468 157.514 199.161 150.73 202.947 144.38C202.947 144.38 210.185 148.977 206.986 157.528L203.468 157.514Z",
    fill: "#00A0F3"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M204.575 157.521C204.575 157.521 206.848 150.355 213.724 148.991C213.724 148.991 215.02 153.646 209.273 157.535L204.575 157.521Z",
    fill: "#00A0F3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M200.102 157.355L201.354 165.877L209.222 165.914L210.38 157.398L200.102 157.355Z",
    fill: "#24285B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M206.935 24.5602H168.449V62.9294H206.935V24.5602Z",
    fill: "#24285B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M180.153 43.3806L184.627 50.799L195.354 36.6838",
    stroke: "white",
    strokeWidth: 3.62055,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.9629,
    y: 56.8085,
    width: 44.9824,
    height: 2.98974,
    rx: 1.49487,
    fill: "#CCD6DD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.9629,
    y: 62.2897,
    width: 44.9824,
    height: 2.98974,
    rx: 1.49487,
    fill: "#CCD6DD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.9629,
    y: 67.7709,
    width: 44.9824,
    height: 2.98974,
    rx: 1.49487,
    fill: "#CCD6DD"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.9629,
    y: 73.252,
    width: 44.9824,
    height: 2.98974,
    rx: 1.49487,
    fill: "#CCD6DD"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.9629,
    y: 78.7332,
    width: 32.9871,
    height: 2.98974,
    rx: 1.49487,
    fill: "#CCD6DD"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.9629,
    y: 84.2144,
    width: 32.9871,
    height: 2.98974,
    rx: 1.49487,
    fill: "#CCD6DD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToCreateProj);
export default __webpack_public_path__ + "static/media/HowToCreateProj.6a5d4761702efd48ae509f1eface5e3c.svg";
export { ForwardRef as ReactComponent };